import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const announcements = [{
  title: 'Picus Security named Innovation Leader for Adversarial Exposure Validation in Gartner Magic Quadrant 2026',
  cta: 'Learn More',
  to: '/company/about'
}, {
  title: 'The 6th Annual Red Report is Live',
  cta: 'Download Now',
  to: '/research/red-report'
}, {
  title: 'Frost and Sullivan picked Picus as the ASV Product of the Year 2026',
  cta: 'Learn More',
  to: '/company/about'
}];
export function HaloBanner() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const goNext = useCallback(() => {
    setDirection(1);
    setIndex(prev => (prev + 1) % announcements.length);
  }, []);
  const goPrev = useCallback(() => {
    setDirection(-1);
    setIndex(prev => (prev - 1 + announcements.length) % announcements.length);
  }, []);
  useEffect(() => {
    const interval = setInterval(goNext, 5000);
    return () => clearInterval(interval);
  }, [goNext]);
  const current = announcements[index];
  const variants = {
    enter: (dir: number) => ({
      opacity: 0,
      y: dir > 0 ? 14 : -14
    }),
    center: {
      opacity: 1,
      y: 0
    },
    exit: (dir: number) => ({
      opacity: 0,
      y: dir > 0 ? -14 : 14
    })
  };
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-picus-accent/20 via-picus-accent/10 to-picus-accent/20 border-b border-picus-accent/30" data-id="element-256">
      <div className="max-w-[1400px] mx-auto px-6 h-10 flex items-center justify-center gap-3 overflow-hidden" data-id="element-257">
        {/* Prev arrow */}
        <button onClick={goPrev} className="flex-shrink-0 p-0.5 rounded-full text-white/40 hover:text-white hover:bg-white/10 transition-colors" aria-label="Previous announcement" data-id="element-258">
          <ChevronLeft className="w-3.5 h-3.5" data-id="element-259" />
        </button>

        {/* Pulsing new badge */}
        <span className="hidden sm:inline-flex items-center gap-1.5 flex-shrink-0" data-id="element-260">
          <span className="relative flex h-2 w-2" data-id="element-261">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-picus-accent opacity-75" data-id="element-262" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-picus-accent" data-id="element-263" />
          </span>
          <span className="text-[11px] font-bold uppercase tracking-widest text-picus-accent" data-id="element-264">
            New
          </span>
        </span>

        {/* Animated title + CTA */}
        <AnimatePresence mode="wait" custom={direction} data-id="element-265">
          <motion.div key={index} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="flex items-center gap-3 min-w-0" data-id="element-266">
            <span className="text-[13px] text-white/90 font-medium leading-tight truncate" data-id="element-267">
              {current.title}
            </span>
            <Link to={current.to} className="flex-shrink-0 inline-flex items-center px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-black bg-picus-accent rounded-full hover:bg-white transition-colors whitespace-nowrap" data-id="element-268">
              {current.cta}
            </Link>
          </motion.div>
        </AnimatePresence>

        {/* Next arrow */}
        <button onClick={goNext} className="flex-shrink-0 p-0.5 rounded-full text-white/40 hover:text-white hover:bg-white/10 transition-colors" aria-label="Next announcement" data-id="element-269">
          <ChevronRight className="w-3.5 h-3.5" data-id="element-270" />
        </button>

        {/* Counter */}
        <span className="hidden sm:inline text-[10px] text-white/30 font-medium tabular-nums flex-shrink-0" data-id="element-271">
          {index + 1}/{announcements.length}
        </span>
      </div>
    </div>;
}